<div class="formSection">
  <div style="display: flex; align-items: start; gap: 40px">
    <div style="flex: 1">
      <app-textbox 
        [label]="'Item Name'"
        [required]="true"
        [showRequired]="true"
        [(ngModel)]="this._data.name"
        [readonly]="this.mode == FormMode.View"
        (ngModelChange)="checkItemValid()"
      ></app-textbox>
      <app-textbox 
        [label]="'Item Description'"
        [required]="true"
        [showRequired]="true"
        [(ngModel)]="this._data.description"
        [readonly]="this.mode == FormMode.View"
        (ngModelChange)="checkItemValid()"
      ></app-textbox>
      <div style="display: flex; align-items: center; gap: 10px">
        <app-textbox 
          [label]="'Price'"
          [required]="true"
          [showRequired]="true"
          [(ngModel)]="this._data.price"
          [type]="InputTextModes.CurrencyUSD"
          [readonly]="this.mode == FormMode.View"
          (ngModelChange)="checkItemValid()"
        ></app-textbox>
        <div
          style="display: flex; align-items: center; gap: 10px; margin: 5px 10px 0 auto;"
        >
          <input
            type="checkbox"
            style="width: 20px; height: 20px"
            [(ngModel)]="this._data.isDiscount"
            [readonly]="this.mode == FormMode.View"
            [disabled]="this.mode == FormMode.View"
            (ngModelChange)="checkItemValid()"
          />
          <p style="font-size: 16px; font-weight: 400; font-family: Booton; color: var(--green-800);">DISCOUNT</p>
        </div>
      </div>
    </div>
  </div>
</div>
